import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { PAGE_SIZES } from '@/components/ui/data-pagination';
import { VideosTab } from '@/pages/record-and-send/videos/videos-tab';
import { VIDEO_SORTS } from '@/pages/record-and-send/videos/videos-search';

const videosSearchSchema = z.object({
	q: z.string().optional().catch(undefined),
	sort: z.enum(VIDEO_SORTS).optional().catch(undefined),
	page: z.coerce.number().int().min(1).optional().catch(undefined),
	pageSize: z.coerce
		.number()
		.refine((size) => PAGE_SIZES.includes(size))
		.optional()
		.catch(undefined),
});

function VideoTypeVideosTab() {
	const { videoTypeId } = Route.useParams();
	return <VideosTab videoTypeId={videoTypeId} />;
}

export const Route = createFileRoute('/_authenticated/_app/record-and-send/video-types/$videoTypeId/videos')({
	validateSearch: videosSearchSchema,
	component: VideoTypeVideosTab,
});
